import React from "react";
import Layout from "../../layout/Layout";
import { Outlet } from "react-router-dom";

const News = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default News;
